import { render, staticRenderFns } from "./VegSingleExpansionPanelWrapper.vue?vue&type=template&id=6f0374f3"
import script from "./VegSingleExpansionPanelWrapper.vue?vue&type=script&lang=ts"
export * from "./VegSingleExpansionPanelWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports